export default __webpack_public_path__ + "static/media/filter.7e197f4f.svg";